export const currentVersion = '7.59';
export const defaultCoordinates = {
  x: 0,
  y: 0,
  z: 0
};
export const env = 'AutodeskProduction';
export const options = {
  headlessViewer: false,
  ignoreGlobalOffset: false,
  viewerConfig: {}
};